var map = {
	"./pay/Close.png": "1c03",
	"./pay/Rectangle.png": "59c6",
	"./pay/Selected.png": "42e6",
	"./pay/U.LULogo_bottom_new.png": "4449",
	"./pay/U.LULogo_top_new.png": "3a57",
	"./pay/USTOREBG.png": "8cc4",
	"./pay/X_btn.png": "8f5b",
	"./pay/downloads.png": "bd14",
	"./pay/loading.svg": "491d",
	"./pay/ulugames_login.png": "6ce4",
	"./pay/ustbtn.png": "8cb7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";